import { gql } from 'graphql-request';

import {
  DownloadID,
  DownloadUUID,
  DownloadCreatedAt,
  DownloadName,
  DownloadFile,
  DownloadStatus,
  DownloadProgress,
  DownloadType,
  DownloadSize,
  DownloadDeviceNanoId,
  DownloadFailedUrlsID,
  DownloadFailedUrlsUrl,
  DownloadFailedUrlsClassName,
  DownloadFailedUrlsUUID,
  DownloadFilesCount
} from '../downloadsTypes';

export interface FetchDownloadsQueryResponse {
  createdAt: DownloadCreatedAt;
  deviceNanoId: DownloadDeviceNanoId;
  failedUrls: {
    id: DownloadFailedUrlsID;
    uuid: DownloadFailedUrlsUUID;
    url: DownloadFailedUrlsUrl;
    className: DownloadFailedUrlsClassName;
  }[];
  file: DownloadFile;
  filesCount: DownloadFilesCount;
  id: DownloadID;
  name: DownloadName;
  progress: DownloadProgress;
  size: DownloadSize;
  status: DownloadStatus;
  type: DownloadType;
  uuid: DownloadUUID;
}

export const FETCH_DOWNLOADS_QUERY = gql`
  query Downloads(
    $filters: DownloadsFilters
    $sort: [DownloadsSortEnum!]
    $limit: Int
    $offset: Int
  ) {
    downloads(filters: $filters, sort: $sort, limit: $limit, offset: $offset) {
      nodes {
        createdAt
        deviceNanoId
        failedUrls {
          id
          uuid
          url
          className
        }
        file
        filesCount
        id
        name
        progress
        size
        status
        type
        uuid
      }
      sql
    }
  }
`;
